import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface IQrCodeProps {
  svg: string;
}

export const QrCode: FC<IQrCodeProps> = ({ svg }) => {
  return <div dangerouslySetInnerHTML={{ __html: svg }} {...stylex.props(styles.container)} />;
};
